module.exports = {
  BackToMain: '返回主画面',
  UserInfo: '个人信息',
  Individual: '页面个性化',
  Cache: '缓存',
  Authorize: '授权',
  CNName: '中文名:',
  Phone: '手机:',
  ENName: '英文名:',
  Tel: '电话:',
  Email: '电子邮件:',
  QQ: 'QQ:',
  MyInfo: '个人资料',
  PersonalEmailSettings: '个人邮箱设置',
  EmailPassword: '邮箱密码/授权码:',
  SignatureSetup: '签名设置',
  ToEnableTheSignature: '启用签名',
  SendTest: '发送测试',
  Edit: '编辑',
  Save: '保存',
  Cancel: '取消',
  ChangePsd: '更改密码',
  ErrorRaised: '错误产生。',
  SaveSucceed: '保存成功。',
  ResetJobCopySucceed: '已可重新设置页面复制条件',
  CancelChange: '确定取消当前修改?',
  Name: '名称',
  company: '公司',
  platformId: '平台ID',
  department: '部门',
  Version: '版本',
  Amount: '总数',
  Filter: '检索:',
  RefreshCache: '刷新缓存',
  ResetCache: '重置缓存',
  Refresh: '刷新',
  Reset: '重置',
  Detail: '查看',
  UserName: '姓名',
  LoginTime: '登录时间',
  ExitTime: '最后操作',
  BackToMyAccount: '退出授权账户',
  AuthHistory: '授权使用历史',
  User: '用户',
  NewAuth: '授权',
  BeginDate: '开始日期',
  EndDate: '截止日期',
  CancalAuth: '撤销授权',
  UseAuth: '使用授权',
  AuthOwned: '当前拥有的授权',
  AuthFail: '授权失败',
  ConfirmAuth: '确认授权',
  InputAuthReason: '请输入授权原因',
  AdminUse: '管理员登录:',
  InvalidUser: '请输入正确的用户和日期!',
  AuthMyself: '不能给自己授权!',
  InputUser: '请输入想要授权的用户名!',
  Tips: '提示',
  SaveYourChange: '存在更改的数据没保存，请在退出授权账户前关闭所有打开的模块！',
  ShutModule: '请在退出授权账户前关闭已经打开的模块,目前打开{0}个模块，是否全部关闭？',
  LoginMySelf: '不需重复登录自己的账号!',
  SelectAccout: '请输入你想要登录的账号!',
  TableColor: '表格颜色',
  StatusName: '状态名称',
  ColorValue: '颜色值',
  PartnerDisplayControl: '数据显示控制',
  PartnerCategory: '数据类别',
  Chinese: '中文',
  English: '英文',
  Code: '代码',
  EnglishAndChinese: '英文+中文',
  ChineseAndEnglish: '中文+英文',
  ShortName: '简称',
  CodeAndChinese: '代码+中文',
  CodeAndEnglish: '代码+英文',
  ShortNameAndChinese: '简称+中文',
  YouDoNotHaveAccessToTheAdministratorAccount: '您无权访问管理员账户',
  Setting: '设置',
  VerificationSettings: '验证弹窗设置',
  ResetJobCopyTittle: '重新设置页面条件',
  ResetJobCopyMessage: '点击设置按钮后，进行复制时会重新显示复制条件设置对话框，可以对复制条件重新进行设置',
  RepeatCopyMessage: '已有相同费用名称，是否再次抄录？',
  WeChatPushRemindTitle: '请扫描以下二维码，并关注“WallTech 沃行信息”公众号',
  WeChatPushRemind1: '请确保您已关注 "WallTech 沃行信息" 公众号,否则无法接收微信消息。',
  WeChatPushRemind2: '微信推送可能存在延迟，一切信息以网页端展示为准。',
  IveFollowed: '我已关注',
  CheckedCategory: '勾选项类别',
  AfterCheckedSelection: '点击重置按钮后，进行投保时会重新显示代理选择页，可以对代理选项重置进行设置',
  FreightInsuranceProvider: '货运险服务商',
  ResetFreightInsuranceProvider: '重置货运险服务商',
  FreightInsuranceProviderReset: '已重置货运险服务商选项',
  CopyBusiness: '复制业务',
  UseSsl: '启用SSL模式',
  Japanese: '日文',
  CustomerSupplierNoChinese: '客户编号/供应商编号+中文',
  threeCharacterCode: '简称+三字码',
  threeCharacterCodeTooltip: '三字码：MAWB Prefix',
  CustomerNoChinese: '客户编号+中文',
  SupplierNoChinese: '供应商编号+中文',
  pageDisplay: '页面显示',
  required: '是否必填',
  b2bWebsite: 'B2B网站',
  b2bWebsiteDisplay: 'B2B网站显示'
}
